import { ReactElement, ReactNode } from "react";
import styles from "./PageWithSidebar.module.scss";

type PageWithSidebarProps = {
  children: ReactNode;
  sidebar: ReactElement;
  contentStyle?: string;
};

export function PageWithSidebar({ children, sidebar, contentStyle = styles.content}: PageWithSidebarProps) {
  return (
    <div>
      <div className={styles.sidebar}>{sidebar}</div>
      <div className={contentStyle}>{children}</div>
    </div>
  );
}
